var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":`/article/${_vm.edition}/${_vm.id}`,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ navigate }){return [_c('div',{staticClass:"teaser",on:{"click":navigate}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('article',{domProps:{"innerHTML":_vm._s(_vm.summary)}})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }